const makeCreateUserCommandFrom = ({authUser, fullName, additionalAttributes})=>{

    const firstAndLastName = getFirstAndLastNameFrom(fullName)
    const createUserCommand = {
      firstName: firstAndLastName.firstName,
      lastName: firstAndLastName.lastName,
      email: authUser.email,
      uid: authUser.uid,
      pictureUrl: authUser.photoURL
    };

    if (additionalAttributes.accountIdForced) createUserCommand.invitedAccountId = additionalAttributes.accountIdForced;
    if (additionalAttributes.inviteeRole) createUserCommand.inviteeRole = additionalAttributes.inviteeRole;
    if (additionalAttributes.inviterUidForced) createUserCommand.inviterUid= additionalAttributes.inviterUidForced
    if (additionalAttributes.invitedToDealId) createUserCommand.invitedToDealId = additionalAttributes.invitedToDealId;
    if (additionalAttributes.userRole) createUserCommand.signedUpAs = additionalAttributes.userRole;
    return createUserCommand
}


const getFirstAndLastNameFrom = (fullName)=>{
    const nameParts = fullName.split(" ");
    var firstName = nameParts[0];
    var lastName = "";
    nameParts[1] ? (lastName += nameParts[1]) : void 0;
    nameParts[2] ? (lastName += " " + nameParts[2]) : void 0;
    nameParts[3] ? (lastName += " " + nameParts[3]) : void 0;
    return {firstName: firstName, lastName: lastName}
}

export { makeCreateUserCommandFrom }


// WEBPACK FOOTER //
// ./src/users/factories/userFactory.js